//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import React, { useEffect, useState } from 'react'

import {
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
  Typography,
  Box,
} from '@mui/material'
import { LENDER_REPORT_DESCRIPTORS, ADMIN_REPORT_DESCRIPTORS } from './ReportDescriptors'
import ReportRowGenerator from './ReportRowGenerator'
import { RoleEnum } from '@shared/Enums'
import { useOtChainState } from '@react/redux/store'

export default function ReportingPage(): React.ReactElement {
  const [reportDescriptorKey, setReportDescriptorKey] = useState<string>('')
  const {
    userConnection: { roleEnum, accountAddr },
  } = useOtChainState()
  useEffect(function initialReportSelect() {
    const _reportDescriptorKey = localStorage.getItem('reportDescriptorKey')

    if (_reportDescriptorKey) {
      setReportDescriptorKey(_reportDescriptorKey)
    } else {
      setReportDescriptorKey('')
    }
  }, [])
  const handleReportDataShapeChange = (event: SelectChangeEvent) => {
    const _reportDescriptorKey = event.target.value as string
    localStorage.setItem('reportDescriptorKey', _reportDescriptorKey)
    setReportDescriptorKey(_reportDescriptorKey)
  }
  const ReportDescriptors =
    roleEnum === RoleEnum.POOL_ADMIN || roleEnum === RoleEnum.BORROWER
      ? ADMIN_REPORT_DESCRIPTORS
      : LENDER_REPORT_DESCRIPTORS
  const reportDescriptor = ADMIN_REPORT_DESCRIPTORS.find(
    (reportDescriptor) => reportDescriptor.key === reportDescriptorKey
  )
  const lenderAddr = roleEnum === RoleEnum.LENDER ? accountAddr : undefined
  return (
    <div style={{ margin: 4 }}>
      <FormControl sx={{ m: 1, width: 350, padding: '15px' }} size="small">
        <InputLabel id="reportShape-label">Report DataSet</InputLabel>
        <Select
          size="small"
          style={{ width: 350 }}
          labelId="reportShape-label"
          id="reportShape-select"
          input={<OutlinedInput id="reportShape-select" label="Report Shape" size="small" />}
          value={reportDescriptorKey}
          renderValue={(key: string) => {
            return (
              <Box sx={{ display: 'flex', alignItems: 'center', height: '32px', pl: 2 }}>
                <Typography variant="bodyBold">
                  {ReportDescriptors.find((reportDescriptor) => reportDescriptor.key === key)?.label ?? 'Unset'}
                </Typography>
              </Box>
            )
          }}
          onChange={handleReportDataShapeChange}
        >
          {ReportDescriptors.map((reportDescriptor) => {
            return (
              <MenuItem
                value={reportDescriptor.key}
                key={reportDescriptor.key}
                style={{
                  paddingLeft: 12,
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                }}
              >
                <Typography sx={{ marginLeft: 2 }} variant="bodyBold">
                  {reportDescriptor.label}
                </Typography>
              </MenuItem>
            )
          })}
        </Select>
      </FormControl>
      {reportDescriptor && (
        <ReportRowGenerator
          lenderAddr={lenderAddr}
          reportDescriptor={reportDescriptor}
          initialLoadWithoutRefresh={false}
        ></ReportRowGenerator>
      )}
    </div>
  )
}
